import { render, staticRenderFns } from "./CommunityHappinessPictureIntroduction.vue?vue&type=template&id=1d252dd4&scoped=true&"
import script from "./CommunityHappinessPictureIntroduction.vue?vue&type=script&lang=js&"
export * from "./CommunityHappinessPictureIntroduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d252dd4",
  null
  
)

export default component.exports